// test2325
(2325 && 0);
